import { trackEvent } from '@/lib/analytics'
import {
  imageUploadedParams,
  postPropertyClickGate,
  sellerListingParams,
  type SellerListingContext,
} from '@/lib/analytics/sellerEventParams'

const clickGate = postPropertyClickGate()

/** User pressed a "Post Property" CTA (not the page load of /add-property). */
export function trackPostPropertyClick(source: string): void {
  if (!clickGate.claim(Date.now())) return
  trackEvent('post_property_click', { source })
}

export function trackPropertyFormStart(context: SellerListingContext): void {
  trackEvent('property_form_start', sellerListingParams(context, 'post_property_wizard'))
}

/** New listing row persisted; it is pending QBC approval, not published. */
export function trackPropertySubmitted(context: SellerListingContext): void {
  trackEvent('property_submitted', {
    ...sellerListingParams(context, 'post_property_wizard'),
    listing_status: 'pending_approval',
  })
}

export function trackPropertyUpdated(context: SellerListingContext): void {
  trackEvent('property_updated', sellerListingParams(context, 'edit_property'))
}

export function trackImageUploaded(propertyId: number, imageCount: number, source: string): void {
  const params = imageUploadedParams(propertyId, imageCount, source)
  if (params) trackEvent('image_uploaded', params)
}
